import { TeamOutlined } from '@ant-design/icons'

import Text from '~/core/Text'

interface QuoteOrderTeamNameProps {
    name: string
}

const QuoteOrderTeamName = (props: QuoteOrderTeamNameProps) => {
    const { name } = props

    return (
        <Text color="blackAlpha45">
            <TeamOutlined style={{ marginRight: '4px' }} />
            Members of {name} can access and edit
        </Text>
    )
}

export default QuoteOrderTeamName
